<template>
  <article>
    <section class="layout-gallery">
      <section class="layout-gallery__row">
        <img src="/images/bloc-solutions/bloc-website-1.png" class="layout-gallery__item -shadow" alt=""/>
      </section>

      <section class="layout-gallery__row">
        <img src="/images/bloc-solutions/bloc-website-2.png" class="layout-gallery__item" alt=""/>
      </section>

      <section class="layout-gallery__row">
        <img src="/images/bloc-solutions/bloc-icons-2.png" class="layout-gallery__item" alt=""/>
      </section>
    </section>

    <section class="layout-gallery">
      <section class="layout-gallery__grid">
        <img src="/images/bloc-solutions/bloc-social-1.png" class="layout-gallery__item -third" alt=""/>
        <img src="/images/bloc-solutions/bloc-social-2.png" class="layout-gallery__item -third" alt=""/>
        <img src="/images/bloc-solutions/bloc-social-3.png" class="layout-gallery__item -third" alt=""/>
        <img src="/images/bloc-solutions/bloc-social-4.png" class="layout-gallery__item -third" alt=""/>
        <img src="/images/bloc-solutions/bloc-social-5.png" class="layout-gallery__item -third" alt=""/>
        <img src="/images/bloc-solutions/bloc-social-6.png" class="layout-gallery__item -third" alt=""/>
      </section>
    </section>

    <section class="layout-gallery">
      <section class="layout-gallery__row">
        <img src="/images/bloc-solutions/bloc-pub.png" class="layout-gallery__item" alt=""/>
      </section>

      <section class="layout-gallery__row">
        <img src="/images/bloc-solutions/bloc-app-1.png" class="layout-gallery__item" alt=""/>
      </section>
    </section>
  </article>
</template>

<script>
export default {
  name: 'BlocGallery'
}
</script>
